export interface PDFElements {
  type: 'text' | 'header' | 'title'
  text: string
}

/**
 * A helper method to create and download PDF files.
 *
 * The elements type can and should be extended as necessary.
 *
 * @param elements
 * @param fileName
 */
export async function downloadPdf(elements: PDFElements[], fileName: string) {
  const { StyleSheet, Document, Page, Text, pdf } = await import(
    /* webpackChunkName: 'pdf-renderer' */
    '@react-pdf/renderer'
  )
  const styles = StyleSheet.create({
    body: {
      paddingVertical: 35,
      paddingHorizontal: 35,
    },
    text: {
      margin: 12,
      fontSize: 12,
      textAlign: 'justify',
    },
    header: {
      fontSize: 18,
      margin: 12,
    },
    title: {
      fontSize: 24,
      textAlign: 'center',
    },
  })

  function Doc() {
    return (
      <Document>
        <Page style={styles.body}>
          {elements.map((ele, i) => (
            <Text key={i} style={styles[ele.type]}>
              {ele.text}
            </Text>
          ))}
        </Page>
      </Document>
    )
  }

  const asPdf = pdf([] as unknown as Parameters<typeof pdf>[0])
  asPdf.updateContainer(<Doc />)
  const blob = await asPdf.toBlob()

  const a = document.createElement('a')
  document.body.appendChild(a)
  a.style.display = 'none'
  a.href = window.URL.createObjectURL(blob)
  a.download = fileName
  a.click()
  window.URL.revokeObjectURL(a.href)
  a.remove()
}
